/* unplugin-vue-components disabled */import { render } from "./Booking.vue?vue&type=template&id=53215190&ts=true"
import script from "./Booking.vue?vue&type=script&lang=ts"
export * from "./Booking.vue?vue&type=script&lang=ts"

import "./Booking.vue?vue&type=style&index=0&id=53215190&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__